import React from 'react';

import {Route, Routes} from 'react-router-dom';

import {IndexPage} from './pages/IndexPage';
import {AddPage} from './pages/AddPage';
import {EditPage} from './pages/EditPage';

const SigninOptionsLayout = () => {
    return (
        <Routes>
            <Route path="add" element={<AddPage />} />
            <Route path=":id" element={<EditPage />} />
            <Route path="/" element={<IndexPage />} />
        </Routes>
    );
};

export default SigninOptionsLayout;
